import { defineAsyncComponent } from 'vue';

export * from './stores/projectModifyView';
export * from './stores/projectDetailsView';
export * from './stores/projectModifyModal';

export * from './components/ProjectReports/reports';
export * from './components/ProjectRevenueForecast';
export * from './components/ProjectTabs/constants';
export * from './components/ProjectModifyModal/constants';
export * from './components/ProjectProfit';

export { default as ProjectAutoSuggest } from './components/ProjectAutoSuggest';
export { default as ProjectDetailsHeader } from './components/ProjectDetailsHeader';

export const projectMicroFrontends = {
	ProjectBudgetAndPricing: defineAsyncComponent(
		() => import('./components/ProjectBudgetAndPricing')
	),
	ProjectReports: defineAsyncComponent(
		() => import('./components/ProjectReports')
	),
	ProjectTabs: defineAsyncComponent(() => import('./components/ProjectTabs')),
	ProjectDetailsHeader: defineAsyncComponent(
		() => import('./components/ProjectDetailsHeader')
	),
	ProjectMetrics: defineAsyncComponent(
		() => import('./components/ProjectMetrics')
	),
	ProjectListMetrics: defineAsyncComponent(
		() => import('./components/ProjectListMetrics')
	),
	ProjectModifyModalsContainer: defineAsyncComponent(
		() =>
			import('./components/ProjectModifyModal/ProjectModifyModalsContainer.vue')
	),
};
